import {
  SortDirection,
  TripClosedReason,
  TripDTO,
  TripStatus,
} from 'src/app/base/models/models.swagger.generated';
import { defineDynamicEntityDefinition, enumColumn } from 'src/app/base/shared/dynamic/dynamic-entity-definition';

export const tripOverviewDynamicDefinition = defineDynamicEntityDefinition<TripDTO, TripDTO, TripDTO>({
  entityName: 'trip',
  primaryKey: 'id',
  defaultSort: {
    field: 'StartUtc',
    direction: SortDirection.Descending,
  },
  grid: {
    searchFields: [],
    columns: [
      { field: 'id', headerKey: 'i18n.shared.fields.id', type: 'number', visible: false, sortable: false, allowFiltering: false },
      { field: 'vehicleId', headerKey: 'i18n.domain.analytics.trip-overview.columns.vehicle-id', type: 'number', visible: false },
      {
        field: 'startUtc',
        headerKey: 'i18n.domain.analytics.trip-overview.columns.start',
        type: 'date',
        clipMode: 'EllipsisWithTooltip',
        filter: { kind: 'date' },
        formatValue: (row: TripDTO) => row.startUtc ? row.startUtc.toFormat('dd.MM.yyyy HH:mm') : '',
      },
      {
        field: 'endUtc',
        headerKey: 'i18n.domain.analytics.trip-overview.columns.end',
        type: 'date',
        clipMode: 'EllipsisWithTooltip',
        filter: { kind: 'date' },
        formatValue: (row: TripDTO) => row.endUtc ? row.endUtc.toFormat('dd.MM.yyyy HH:mm') : '',
      },
      enumColumn<TripDTO>('status', 'i18n.domain.analytics.trip-overview.columns.status', {
        enumType: TripStatus,
        enumName: 'TripStatus',
      }),
      enumColumn<TripDTO>('closedReason', 'i18n.domain.analytics.trip-overview.columns.closed-reason', {
        enumType: TripClosedReason,
        enumName: 'TripClosedReason',
      }),
      {
        field: 'accumulatedDistanceKm',
        headerKey: 'i18n.domain.analytics.trip-overview.columns.distance',
        type: 'number',
        filter: { kind: 'number' },
      },
      {
        field: 'accumulatedFuelUsedL',
        headerKey: 'i18n.domain.analytics.trip-overview.columns.fuel',
        type: 'number',
        filter: { kind: 'number' },
      },
      {
        field: 'accumulatedRuntimeMin',
        headerKey: 'i18n.domain.analytics.trip-overview.columns.runtime',
        type: 'number',
        filter: { kind: 'number' },
      },
    ],
  },
  form: {
    fields: [],
    layout: [],
  },
  // Trip data is read-only (StatisticsController only exposes SearchTrips/GetTrip) — add/edit are never triggered
  // since the grid disables allowAdding/allowEditing/allowDeleting, so these are unused identity pass-throughs.
  mapToCreate: (formValue: TripDTO): TripDTO => formValue,
  mapToUpdate: (formValue: TripDTO): TripDTO => formValue,
});
